export const ACTION_STATUS_ADD = 'ACTION_STATUS_ADD';
export const ACTION_STATUS_REMOVE = 'ACTION_STATUS_REMOVE';
export const ACTION_CLEAR_ACTION_STATUS_STORE = 'ACTION_CLEAR_ACTION_STATUS_STORE';

/* ------------- Initial State ------------- */
export const ACTION_STATUS_INITIAL_STATE = {};
